module.exports = __webpack_public_path__ + "img/aggregate.0923f616.png";